<template>
  <md-dialog :md-active.sync="showPopup"
             @click="closePopup"
             @md-closed="closePopup"
             :md-backdrop="false"
             class="main-popup__wrap">
    <div class="main-popup">
      <div v-if="icon" class="main-popup__icon" :class="'main-popup__icon-' + icon">
        <div class="icon__circle" :class="icon + '__icon'">
        </div>
      </div>
      <div v-if="title" class="main-popup__title" v-html="title"></div>
      <div v-if="subTitle" class="main-popup__sub-title" :class="{'align-center': alignCenter}" v-html="subTitle"></div>
      <div v-if="text" class="main-popup__text" :class="{'align-center': alignCenter}" v-html="text"></div>
      <div v-if="confirmAction || cancelAction" class="btn-wrap space-between margin-top">
        <md-button v-if="confirmAction"
                   @click="submitPopup()"
                   class="btn md-primary"
                   :disabled="disabled"
        >{{ actionsText.confirm }}</md-button>
        <md-button v-if="cancelAction"
                   @click="closeByClick = true; closePopup()"
                   class="btn md-primary"
        >{{ actionsText.cancel }}</md-button>
      </div>
    </div>
  </md-dialog>
</template>

<script>
  import { i18n } from '@js/i18n'
  import { commonEvents } from '@js/events/common_events'

  export default {
    name: 'main-popup',
    props: {
      showPopup: { type: Boolean, default: false },
      closeByClick: { type: Boolean, default: false },
      // showIcon: { type: Boolean, default: false },
      confirmAction: { type: Boolean, default: true },
      cancelAction: { type: Boolean, default: false },
      actionsText: {
        confirm: { type: String, default: i18n.lbl_accept() },
        cancel: { type: String, default: i18n.lbl_cancel() }
      },
      icon: { type: String, default: 'confirm' },
      title: '',
      subTitle: '',
      text: '',
      alignCenter: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false }
    },
    data () {
      return {
        i18n
      }
    },
    mounted () {},
    computed: {},
    created () {
    },
    beforeDestroy () {
    },
    methods: {
      closePopup () {
        if (!this.closeByClick) return
        this.$emit(commonEvents.closePopupEvent, false)
      },
      submitPopup () {
        this.$emit(commonEvents.submitPopupEvent, false)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~scss/mixins";
  @import "~scss/variables";

  .main-popup {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 640px;
    height: auto;
    margin: 150px auto;
    padding: 60px 75px;
    text-align: center;
    border-radius: 10px;
    @include respond-to(medium) {
      width: 440px;
      height: auto;
    }

    &__wrap {
      position: fixed;
      top: 0;
      left: 265px;
      right: 0;
      bottom: 0;
      width: calc(100vw - 265px);
      height: 100%;
      margin: 0;
      max-width: unset;
      max-height: unset;
      background: rgba(28, 78, 89, 0.4);
      -webkit-backdrop-filter: blur(5px);
      backdrop-filter: blur(5px);
      transform: translate(0, 0);
      @include respond-to(small) {
        left: 0;
        width: 100%;
      }
    }

    &__title {
      margin: 20px auto 10px;
      font-size: 32px;
      line-height: 150%;
      font-weight: 600;
    }

    &__sub-title {
      margin: 10px auto;
      font-size: 20px;
      line-height: 150%;
      font-weight: 600;
      text-align: left;
    }

    &__text {
      margin: 10px auto;
      font-size: 16px;
      line-height: 24px;
      text-align: left;
    }

    /*&__actions {
      margin-top: 20px;

      & .btn {
        & .md-button-content {
          padding: 0 35px;
        }
      }

      & .btn-simple {
        color: $col-text;
        & .md-button-content {
          color: $col-text !important;
        }
      }

      !*& . {
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
      }
      & .btn-cancel {
        border: 1px solid rgba(203, 226, 230, 0.5);
        color: $col-text;
        & /deep/ .md-button-content {
          color: $col-text;
        }
      }*!
    }*/

    &__icon {
      width: 46px;
      height: 46px;
      margin: 0 auto;
      padding: 11px 0;
      background-color: $col-md-primary;
      border-radius: 46px;

      &-success {
        background-color: $green;
      }
    }

    & .confirm__icon,
    & .success__icon {
      width: 24px;
      height: 18px;
      margin: 2px auto;
      background: url("/static/img/old/confirm_icon_big.svg") no-repeat center center;
    }

    & .align-center {
      text-align: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/common/popups/PopupMain.vue